/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DriftStatusBesked } from '../models/drift-status-besked';
@Injectable({
  providedIn: 'root',
})
class AlertService extends __BaseService {
static readonly getDriftStatusPath = '/alert';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @return Success
   */
  private getDriftStatusResponse(): __Observable<__StrictHttpResponse<Array<DriftStatusBesked>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/alert`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DriftStatusBesked>>;
      })
    );
  }

  /**
   * @return Success
   */
  getDriftStatus(): __Observable<Array<DriftStatusBesked>> {
    return this.getDriftStatusResponse().pipe(
      __map(_r => _r.body as Array<DriftStatusBesked>)
    );
  }
}

module AlertService {
}

export { AlertService }
